import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { TYPOGRAPHY_SIZE } from 'mm-theme-configuration/dist/consts';
import { VrLineHeight } from '../../theming/verticalRhythm/verticalRhythm';
import { MandatoryAdditionalStyle } from '../components.utils';
import { useTheme } from '../../theming/useTheme';
import { ErrorBoundary } from '../errorHandling/ErrorBoundary';
import { H3, Span, semanticCSS } from '../../typography/semanticTags';
import { SemanticTagThemeProps, getStyleBySize } from '../../typography/semanticTags/semanticTags.utils';


const componentConfigurationKey = 'listItemTitle';

interface ListItemTitleComponentDataProps {
  listItemNumber: string,
  text: string
  dataId?: string
}

interface ListItemTitleComponentThemeProps extends SemanticTagThemeProps {
  titleColor: string
  numberColor: string
  vrLineHeight: VrLineHeight
}

type ListItemTitleComponentProps = ListItemTitleComponentDataProps & ListItemTitleComponentThemeProps & MandatoryAdditionalStyle;

const getStyle = (theme: ListItemTitleComponentThemeProps) => StyleSheet.create({
  numberStyle: {
    color: theme.numberColor,
  },
  titleStyle: {
    color: theme.titleColor,
  },
});

export const ListItemTitleComponent: React.FunctionComponent<ListItemTitleComponentProps> = props => {
  const { listItemNumber, text, additionalStyle, dataId, fontSizesStyles } = props;
  const { numberStyle, titleStyle } = getStyle(props);
  const contentStyle = getStyleBySize(fontSizesStyles, TYPOGRAPHY_SIZE.LARGE);

  return (
    <H3 data-id={dataId} styles={semanticCSS(additionalStyle.style, titleStyle)}>
      <Span styles={semanticCSS(numberStyle, contentStyle)}>
        {`${listItemNumber}. `}
      </Span>
      {text}
    </H3>
  );
};

const mapThemeProps = (theme: ListItemTitleComponentThemeProps) => {
  return {
    titleColor: theme.titleColor,
    numberColor: theme.numberColor,
    vrLineHeight: theme.vrLineHeight,
    fontSizesStyles: theme.fontSizesStyles,
  };
};

export const ListItemTitle = (props: ListItemTitleComponentDataProps & MandatoryAdditionalStyle) => {
  const themeContext = useTheme(mapThemeProps, componentConfigurationKey);
  return <ErrorBoundary><ListItemTitleComponent {...themeContext} {...props} /></ErrorBoundary>;
};
